(() => {
  const DESCRIPTION_SELECTOR = '.desc-variant[data-variant]';

  function getVariantId(value) {
    if (value === null || value === undefined) return '';
    return String(value);
  }

  function showVariantDescription(variantId, root = document) {
    const id = getVariantId(variantId);
    if (!id) return;

    root.querySelectorAll(DESCRIPTION_SELECTOR).forEach((description) => {
      const isActive = description.dataset.variant === id;
      description.hidden = !isActive;
      description.style.display = isActive ? '' : 'none';
    });
  }

  function getInitialVariantId(root = document) {
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    if (urlVariantId) return urlVariantId;

    const selectedVariantInput = root.querySelector(
      'select[name="id"], input[name="id"]:checked, input[name="id"]'
    );

    return selectedVariantInput ? selectedVariantInput.value : '';
  }

  function getVariantIdFromEvent(event) {
    return (
      event.detail?.variant?.id ??
      event.detail?.variantId ??
      event.detail?.id ??
      event.variant?.id ??
      event.target?.value
    );
  }

  function initialize(root = document) {
    if (!root.querySelector(DESCRIPTION_SELECTOR)) return;
    showVariantDescription(getInitialVariantId(root), root);
  }

  document.addEventListener('variant:change', (event) => {
    showVariantDescription(getVariantIdFromEvent(event));
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('select[name="id"], input[name="id"]')) return;
    showVariantDescription(event.target.value);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
